import Connections from '../../connections';
import {
  action, observable,
} from 'mobx';
import {
  createFacilityCategory, getFacilityCategories, getFacilityCategoryById, updateFacilityCategory, updateFacilityCategoryStatus,
} from '../../axios/facilitiesCategoriesRequests';
import {
  convertCountriesToISOCodeString,
} from '../../constants/countries';
import {
  DefaultLanguage,
} from '../../constants/languages';
import {
  getHeader,
} from '../../helperFunctions/getHeader';
import {
  ICountry,
} from '../storeInterfaces/authInterface';
import {
  ICategory, CategoryModel,
} from '../storeInterfaces/categoryInterface';
import {
  IfacilitiesCategoriesStore,
} from '../storeInterfaces/facilitiesCategoriesInterface';
import { uploadFile, uploadSingleImage } from '../../helperFunctions/uploadService';
import { uploadFileURL } from '../../axios/requests';
import { RequestStatus } from 'mobx-store';

export class FacilitiesCategoriesStore implements IfacilitiesCategoriesStore {
  @observable categoriesList: ICategory[] = [];

  @observable selectedCategory = {
  };

  @observable loading = false;

  @observable getFacilitiesCategoriesRequestStatus: RequestStatus = RequestStatus.IDLE;

  private static restructureFacilityCategory(category: ICategory): any {
    return {
      categoryId: category.facilityCategoryId,
      title: category.title,
      isActive: category.isActive,
      imageUrl: (category.imageUrl ? [{
        imageUrl: category.imageUrl,
      }] : []),
    };
  }

  private static restructureFacilityCategoriesList(categories: ICategory[]): any[] {
    return categories.map((category: ICategory) => ({
      ...category,
      editForm: 'Edit Form',
    }));
  }

  @action
  public async getFacilityCategories(countries: ICountry[], type: string, langCode: string = DefaultLanguage): Promise<void> {
    try {
      this.loading = true;
      this.getFacilitiesCategoriesRequestStatus = RequestStatus.LOADING;
      const availableCountries = convertCountriesToISOCodeString(countries);

      const params = {
        availableCountries,
        status: 'all',
        facilityCategoryType: type,
      };

      const config = {
        ...getHeader(langCode), params,
      };

      const response = await Connections.wadiDeglaAxios.httpGet(getFacilityCategories, config);
      this.categoriesList = FacilitiesCategoriesStore.restructureFacilityCategoriesList(response.data);
      this.getFacilitiesCategoriesRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getFacilitiesCategoriesRequestStatus = RequestStatus.FAILED;
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async getFacilityCategoryById(id: number, langCode: string = DefaultLanguage): Promise<void> {
    try {
      this.loading = true;
      const response = await Connections.wadiDeglaAxios.httpGet(getFacilityCategoryById(id), getHeader(langCode));
      this.selectedCategory = FacilitiesCategoriesStore.restructureFacilityCategory(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async createFacilityCategory(newCategory: ICategory, langCode: string = DefaultLanguage): Promise<void> {
    return new Promise<void>(async (res, rej) => {
      try {
        let imageUrl = null;
        if (newCategory.imageUrl) {
          imageUrl = await uploadSingleImage(newCategory.imageUrl);
        }
        const categoryToCreate: CategoryModel = {
          facilityCategoryId: newCategory.facilityCategoryId,
          imageUrl,
          isActive: newCategory.isActive,
          title: newCategory.title,
          type: newCategory.type,
          availableCountries: newCategory.availableCountries,
        };
        const response = await Connections.wadiDeglaAxios.httpPost(createFacilityCategory, categoryToCreate, getHeader(langCode));
        res(response.data.facilityCategoryId);
      } catch (error) {
        rej(error);
      }
    });
  }

  @action.bound
  public async updateFacilityCategoryStatus(updatedCategoryStatus: boolean, index: number): Promise<void> {
    try {
      await Connections.wadiDeglaAxios.httpPut(updateFacilityCategoryStatus(this.categoriesList[index].facilityCategoryId),
        {
          isActive: updatedCategoryStatus,
        });
    } catch (error) {
      console.log(error);
    } finally {
      this.categoriesList[index].isActive = updatedCategoryStatus;
    }
  }

  @action.bound
  public async updateFacilityCategory(updatedCategory: ICategory, categoryId: number, langCode: string = DefaultLanguage): Promise<void> {
    try {
      let imageUrl = null;
        if (updatedCategory.imageUrl) {
          imageUrl = await uploadSingleImage(updatedCategory.imageUrl);
        }
      const categoryToUpdate: CategoryModel = {
        facilityCategoryId: updatedCategory.facilityCategoryId,
        imageUrl,
        isActive: updatedCategory.isActive,
        title: updatedCategory.title,
        type: updatedCategory.type,
        availableCountries: updatedCategory.availableCountries,
      };
      await Connections.wadiDeglaAxios.httpPut(updateFacilityCategory(categoryId), categoryToUpdate, getHeader(langCode));
    } catch (error) {
      console.log(error);
    }
  }
}
